import script from "./EvaluationView.vue?vue&type=script&setup=true&lang=js"
export * from "./EvaluationView.vue?vue&type=script&setup=true&lang=js"

import "./EvaluationView.vue?vue&type=style&index=0&id=39f3eaa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f3eaa2"]])

export default __exports__